<template>
    <div>
        <div id="footer" class="footer linear-gradient-bg">
            <div class="separator"></div>
                <div class="container">
                    <div class="row">
                        <div class="d-none d-sm-block col-sm-4">
                            <strong>Hay Đọc Truyện - Nover</strong>
                            - 
                            <a href="/" title="Đọc truyện online">Đọc truyện</a> online, 
                            <a href="/" title="Đọc truyện chữ">đọc truyện</a> chữ, 
                            <a href="/" title="Truyện hay">truyện hay</a>. Website luôn cập nhật những bộ 
                            <a href="/" title="Truyện mới">truyện mới</a> thuộc các thể loại đặc sắc như 
                            <a href="/" title="Truyện tiên hiệp">truyện tiên hiệp</a>, 
                            <a href="/" title="Truyện kiếm hiệp">truyện kiếm hiệp</a>, hay 
                            <a href="/" title="Truyện ngôn tình">truyện ngôn tình</a> một cách nhanh nhất. Hỗ trợ mọi thiết bị như di động và máy tính bảng.
                        </div>
                        <div class="d-none d-sm-block col-sm-6">
                            <a href="https://sites.google.com/view/nover-privacy-policy/home">Privacy Policy</a> -
                            <a href="https://sites.google.com/view/nover-terms/home">Terms of Service</a>
                        </div>
                        <div class="app-text col-xs-12 col-sm-2">
                            <a href="https://apps.apple.com/app/id1440101200" title="iOS">iOS</a> - 
                            <a href="https://play.google.com/store/apps/details?id=net.astrangestudio.noff" title="Android">Android</a>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.footer {
    padding-bottom: 3rem;
    font-size: 1.5rem;
    color: white;

    .container {
        margin-top: 3rem;
    }

    a {
        font-size: 1.5rem;
        color: white;
    }

    .tag-list {
        a {
            font-size: 12px;
            white-space: nowrap;
            border: 1px solid #E8E8E8;
            display: inline-block;
            padding: 2px 5px;
            margin: 2px 2px 2px 0;
            text-decoration: none;
            text-align: center;
            border-radius: 0;
        }
    }

    .app-text {
        padding-left: 1.5rem;
        height: 26px;
        font-weight: 700;
    }
}
</style>